import Card from './Card';

export default class CandyCard extends Card {

    onAfterCardThrownFromPlayerToUsedPile = () => {
        // onAfterCardThrownFromPlayerToUsedPile is launched for a Candy Card
    }
}
